export const validation = {
	emailFormatError: { sv: "Den där e-postadressen ser inte rätt ut" },
	phoneNumberFormatError: { sv: "Det där telefonnumret ser inte rätt ut" },
	mandatory: { sv: "Fyll i det här fältet" },
	mandatoryEmail: { sv: "Skriv in mailadress" },
	mandatoryPhone: { sv: "Skriv in telefonnummer" },
	invalidBg: { sv: "Felaktigt nummer" },
	invalidSsn: { sv: "Felaktigt personnummer" },
	invalidSsnCPOC: { sv: "Skriv in personnummer, 12 siffror" },
	packageNotSelected: {
		sv: "Du behöver välja ett paket innan du kan gå vidare",
	},
	onlyNumbersAllowed: { sv: "Endast siffror är tillåtna" },
	invalidSniCode: { sv: "Ogiltig SNI-kod" },
	minCredit: { sv: "Minsta kredit är {0}" },
	maxCredit: { sv: "Högsta kredit är {0}" },
	evenThousand: { sv: "Beloppet måste vara jämt tusental" },
	invalidDate: { sv: "Ogiltigt datum" },
	maxLength: { sv: "Texten får inte vara mer än {0} tecken" },
	minLength: { sv: "Texten måste vara minst {0} tecken" },
	invalidZipCode: { sv: "Felaktigt postnummer" },
	atLeastOne: { sv: "Välj minst ett alternativ" },
	chooseOne: { sv: "Du måste välja ett alternativ" },
	mustSelect: { sv: "Detta fält är obligatoriskt" },
	emailDoesNotMatch: { sv: "Mejladresserna matchar inte" },
	invalidCompanyName: { sv: "Ogiltigt namn" },
	invalidPaymentAmount: { sv: "Ogiltigt belopp" },
	invalidSharesDistributed: { sv: "Alla aktier måste fördelas" },
	minimumAmount: { sv: "Beloppet måste vara minst {0} kr" },
	personAlreadyAdded: { sv: "Personen är redan tillagd" },
	phoneAlreadyAdded: { sv: "Telefonnumret används redan" },
	emailAlreadyAdded: { sv: "Mejladressen används redan" },
	invalidIban: { sv: "IBAN ser inte rätt ut. Försök igen." },
	invalidClearingNumber: { sv: "Kontrollera clearingnummer" },
	missingSwishNumber: { sv: "Fyll i ett Swishnummer för att fortsätta" },
	invalidSwishNumber: { sv: "Dubbelkolla att Swishnumret stämmer" },
	giroFormatError: {
		sv: "Det där gironumret ser inte rätt ut. Försök igen.",
	},
	onlyCertainCharactersAllowed: {
		sv: "Meddelandet får bara innehålla bokstäver, siffror och punkter",
	},
	hasNoBeneficialOwners: {
		sv: "Du behöver välja verkliga huvudmän",
	},
	missingBeneficialOwnerDetails: {
		sv: "Du måste fylla i uppgifter om kontroll och omfattning för varje verklig huvudman",
	},
	invalidFormFields: {
		sv: "Följande fält är felaktiga:",
	},
};
